import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// components
import BookADemoButton from '../../ui/BookADemoButton'
// views
import AnimatedContainer from '../../ui/AnimatedContainer/animatedContainer'
import {
  descriptionAnimation,
  titleAnimation,
  subtitleAnimation,
} from '../../../constants/animation'
// assets
import Glow from '../../glows'
import RPOImg from '../../../assets/imgs/rpo/rpo.png'

const RPOComponent = () => {
  return (
    <section className='overview-section rpo-content'>
      <div className='box'>
        <Glow position='right' />

        <AnimatedContainer className='rpo-grid-container'>
          <div>
            <motion.p
              className='overview-title rpo-overview-title'
              variants={titleAnimation}
            >
              Optimize Recruitment with Visibility into All Talent Pipelines
            </motion.p>
            <br/>
            <motion.p className='rpo-subtitle' variants={subtitleAnimation}>
              Win new business, deliver measurable ROI, and become indispensable
              to clients.
            </motion.p>
            <motion.p className='description' variants={descriptionAnimation}>
              Pod gives RPOs a client-branded platform that embeds their
              services directly into hiring workflows. By providing full
              visibility across active candidates, silver-medalist pools, and
              internal talent, Pod strengthens client loyalty and makes
              switching providers harder. Demo-ready instances let you showcase
              real client data in minutes, helping you land and expand accounts
              faster.
            </motion.p>
            <div className='rpo-button-container'>
              <BookADemoButton />
            </div>
          </div>
          <div className='img-container'>
            <img className='rpo-image' src={RPOImg} alt='RPO Presentation' />
          </div>
        </AnimatedContainer>
      </div>
    </section>
  )
}

export default RPOComponent
